import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import { getEnv } from '@config';

const { gtmContainerKey: GTM_CONTAINER_KEY, gtmURL: GTM_URL } = getEnv();

/**
 * Inicializa GTM con la variable de entorno GTM_CONTAINER_KEY
 */
const gtmInit = () =>
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    // eslint-disable-next-line eqeqeq
    const dl = l != 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `${GTM_URL}?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', GTM_CONTAINER_KEY);

/**
 * Pushea variables al datalayer de GTM
 * @param  {Object} relationObject
 */
export const dataLayerPush = (relationObject) => {
  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    window.dataLayer.push(relationObject);
  }
};

export const hashUserId = (docNumber) => Base64.stringify(sha256(docNumber));

export const dataLayerUserIdPush = (docNumber) => {
  const userID = hashUserId(docNumber);
  dataLayerPush({ userID });
};

export default gtmInit;
